/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ year: NonNullable<unknown>, name: NonNullable<unknown> }} Landing_Footer_CopyrightInputs */

const en_landing_footer_copyright = /** @type {(inputs: Landing_Footer_CopyrightInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`© ${i?.year} ${i?.name} Limited. Inginuiti® is a registered trademark.`)
};

/**
* | output |
* | --- |
* | "© {year} {name} Limited. Inginuiti® is a registered trademark." |
*
* @param {Landing_Footer_CopyrightInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const landing_footer_copyright = /** @type {((inputs: Landing_Footer_CopyrightInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Footer_CopyrightInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_footer_copyright(inputs)
});